import { Popover } from 'antd';
import React from 'react';

import { UseTranslateType } from '@/hooks/useTranslate';
import { fc_purchase_alert_expose } from '@/utils/eventlog/eventNewConfig';

import RingIcon from '../../icon/ring';
import { FWebsiteEmail } from '../../payment/us/utils';
import styles from '../../style.module.scss';
import DoubleArrowIcon from '../icon/doubleArrow';
import TipIcon from '../icon/tip';

interface footerProps {
  t: UseTranslateType;
  feature: fc_purchase_alert_expose['from'];
}

const Footer: React.FC<footerProps> = ({ t }) => {
  return (
    <>
      <div className="text-payment-modal-card-title-color  font-[500] leading-[22px] flex justify-center items-center pt-[20px] gap-[4px] select-none">
        <p className="max-w-[860px] text-center">
          <RingIcon className="text-common-text-base-color inline scale-110 relative left-[-6px] top-[-2px]" />
          {t('Tips-credits-have-a-validity-period-of-1-years-aft')}{' '}
          <span
            className="text-payment-modal-card-link-color hover:text-payment-modal-card-link-hover-color transition-colors text-[16px] font-[500] cursor-pointer select-none"
            onClick={() => {
              window.open(
                'https://quvideo.feishu.cn/wiki/MqU9wtrEji9ZMykz2AXcKxBsnld',
                '_blank',
              );
            }}
          >
            {t && t('credit rule')}
          </span>
        </p>
      </div>
      <div className={`pb-[16px] pt-[14px] flex justify-center items-center`}>
        <Popover
          classNames={{ root: styles['tip-popover'] }}
          align={{
            offset: [0, -10],
          }}
          destroyOnHidden
          placement="top"
          content={
            <div className="text-[#f3f3f3] text-[12px] font-[600]">
              {t('no-email-tip', {
                email: FWebsiteEmail,
              })}
            </div>
          }
        >
          <div className="pr-[6px]">
            <TipIcon stroke="#8A94F8" />
          </div>
        </Popover>

        <span
          className="text-payment-modal-card-link-color hover:text-payment-modal-card-link-hover-color transition-colors text-[16px] font-[500] cursor-pointer select-none"
          onClick={() => {
            window.location.href = 'mailto:' + FWebsiteEmail;
          }}
        >
          {t && t('Purchase-more-credits')}
        </span>

        <DoubleArrowIcon />
      </div>
    </>
  );
};

export default Footer;
